import { UserUpdateRequest } from "@/clients/models/UserUpdateRequest";
import { UsersService } from "@/clients/services/UsersService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useUser } from "@clerk/clerk-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateUser = () => {
  const { user: clerkUser } = useUser();
  const queryClient = useQueryClient();

  const updateUserMutation = useMutation({
    mutationKey: [QueryKeys.USER],
    mutationFn: async (userUpdateRequest: UserUpdateRequest) => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await UsersService.updateProfileInfoApiV1UsersPut(
        user?.id ?? clerkUser?.id ?? "",
        userUpdateRequest,
      );

      return data;
    },
    onSuccess: () => {
      // dob/sex changes recompute calories & macros on the backend.
      // Name-only updates trigger a harmless extra refetch.
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.NUTRITIONAL_REQUIREMENT],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.CALORIE_BUDGET],
      });
    },
  });

  return {
    updateUser: updateUserMutation.mutate,
    updateUserAsync: updateUserMutation.mutateAsync,
    isUpdating: updateUserMutation.isPending,
    isError: updateUserMutation.isError,
    error: updateUserMutation.error,
  };
};
